<script>

import Swal from "sweetalert2";

export default {
  setup() {
    return { };
  },
  components: {

  },
  props: {
    dataList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    updating: {
      type: Boolean,
    },
  },
  mounted() {
    console.log('mounted receitas-table_0')
    console.log(this.dataList)
  },
  methods: {

    editar(dataID){
      console.log('editar: ' + dataID)
      this.showModal = true
      this.regSelecionado = this.dataList.find((reg) => reg.id === dataID);
      console.log('regSelecionado: ')
      console.log(this.regSelecionado)

    },

    deletar(dataID){
      console.log('deletar: ' + dataID)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações excluídas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          });
        }
      })

    },


  },
  data() {
    return {
      regSelecionado: {},
      showModal: false,
    };
  },
};
</script>

<template>
  <div class="table-responsive mb-0">
    <table class="table align-middle table-nowrap">
      <thead class="table-light">
      <tr>
        <th class="align-middle">Código</th>
        <th class="align-middle">Nome</th>
        <th class="align-middle">Email</th>
        <th class="align-middle">Telefone</th>
        <th class="align-middle">Status</th>
        <th class="align-middle">Estado</th>
        <th class="align-middle">Emissão</th>
        <th class="align-middle">Vencimento</th>
        <th class="align-middle text-end">Valor</th>
        <th class="align-middle">Ações</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="data in dataList" :key="data.id">

        <td>
          <a href="javascript: void(0);" class="text-body fw-bold" @click="editar(data.id)">{{
              data.id
            }}</a>
        </td>

        <td>{{ data.descricao }} </td>
        <td>{{ data.email }} </td>
        <td>{{ data.telefone }} </td>
        <td>
              <span
                  class="badge badge-pill badge-soft-success font-size-11"
                  :class="{
                  'badge-soft-danger': `${data.status}` === 'Cancelado',
                  'badge-soft-warning': `${data.status}` === 'Análise',
                }">
                {{ data.status }}
              </span>
        </td>

        <td> {{ data.estado }}</td>
        <td>{{ data.date }} </td>
        <td>{{ data.date }} </td>
        <td class="text-end">{{ data.total }} </td>


        <td>
          <div class="button-items">

            <b-button variant="outline-success" @click="editar(data.id)">
              <i class="mdi mdi-eye d-block font-size-16"></i>
            </b-button>

          </div>
        </td>


      </tr>
      </tbody>
    </table>

    <b-modal title="Detalhes Lançamento Financeiro" v-model="showModal" hide-footer>
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <div class="col-12">
            <div class="input-group mb-3">
              <input type="text"
                     v-model="regSelecionado.descricao"
                     class="form-control"
                     id="descricao"
                     aria-describedby="inputGroupFileAddon03"
                     aria-label="Upload"
                     disabled/>
              <router-link :to="`/clientes/detalhe/0`"
                           target="_blank"
                           class="btn btn-primary"
                           type="button"
                           id="inputGroupFileAddon03">
                <i class="mdi mdi-open-in-new"></i>
              </router-link>
            </div>

          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="emissao">Emissão</label>
              <input
                  id="emissao"
                  v-model="regSelecionado.date"
                  type="text"
                  class="form-control text-end"
                  disabled/>
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="vencimento">Vencimento</label>
              <input
                  id="vencimento"
                  v-model="regSelecionado.date"
                  type="text"
                  class="form-control text-end"
                  disabled/>
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="quitacao">Quitação</label>
              <input
                  id="quitacao"
                  v-model="regSelecionado.date"
                  type="text"
                  class="form-control text-end"
                  disabled/>
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="juros">Valor Juros</label>
              <input id="juros"
                     type="text"
                     class="form-control text-end"
                     disabled/>
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="selectStatus">Status</label>
              <b-form-select
                  id="selectStatus"
                  v-model="regSelecionado.status"
                  disabled
                  class="mb-3 form-select form-control">
                <b-form-select-option value="Quitado"> Quitado </b-form-select-option>
                <b-form-select-option value="Cancelado"> Cancelado </b-form-select-option>
                <b-form-select-option value="Análise"> Análise </b-form-select-option>
              </b-form-select>
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="total">Valor</label>
              <input
                  id="total"
                  v-model="regSelecionado.total"
                  type="text"
                  class="form-control text-end"
                  disabled/>
            </div>
          </div>



        </div>

        <div class="text-end mt-3">

          <b-button variant="light" @click="showModal = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Fechar
          </b-button>

          <!--          <b-button type="submit" variant="success" class="ms-1" @click="confirmar">-->
          <!--            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>-->
          <!--            Confirmar-->
          <!--          </b-button>-->
        </div>

      </form>

    </b-modal>

  </div>

</template>
